"use client";

import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/admin/drawings')({
  component: AdminDrawingsLayout,
})

function AdminDrawingsLayout() {
  return <Outlet />
}
